import { atom } from 'jotai';
import { ReactNode } from 'react';

export const rightPaneExpandedAtom = atom<boolean>(true);
rightPaneExpandedAtom.debugLabel = 'rightPaneExpandedAtom';

export const rightPaneEnabledAtom = atom<boolean>(false);
rightPaneEnabledAtom.debugLabel = 'rightPaneEnabledAtom';

export const rightPaneContentAtom = atom<ReactNode | null>(null);
rightPaneContentAtom.debugLabel = 'rightPaneContentAtom';

export const rightPaneTitleAtom = atom<string | null>(null);
rightPaneTitleAtom.debugLabel = 'rightPaneTitleAtom';

export const rightPaneCollapsedContentAtom = atom<ReactNode | null>(null);
rightPaneCollapsedContentAtom.debugLabel = 'rightPaneCollapsedContentAtom';
